import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult({ kind }) {
  const { t } = useLang();
  const location = useLocation();
  const [state, setState] = useState(kind === "cancel" ? "cancelled" : "checking");

  useEffect(() => {
    const sid = new URLSearchParams(location.search).get("session_id");
    if (kind === "cancel") {
      if (sid) axios.post(`${API}/academy/release`, { session_id: sid }).catch(() => {});
      return;
    }
    if (!sid) {
      setState("failed");
      return;
    }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/academy/status/${sid}`);
        if (r.data.status === "confirmed") {
          setState("confirmed");
          return;
        }
        if (r.data.status === "expired" || r.data.status === "failed") {
          setState("failed");
          return;
        }
      } catch {}
      if (++tries < 15) timer = setTimeout(poll, 2000);
      else setState("failed");
    };
    poll();
    return () => clearTimeout(timer);
  }, [kind, location.search]);

  const title =
    state === "confirmed" ? t("academy.success_title")
    : state === "cancelled" ? t("academy.cancel_title")
    : t("academy.success_failed");
  const body =
    state === "confirmed" ? t("academy.success_body")
    : state === "cancelled" ? t("academy.cancel_body")
    : t("academy.success_failed");

  return (
    <div data-testid={`payment-${kind}`} className="min-h-[70vh] flex items-center justify-center px-5 py-24">
      {state === "checking" ? (
        <p data-testid="payment-checking" className="font-serif font-light text-2xl md:text-3xl text-foreground/70">
          {t("academy.success_checking")}
        </p>
      ) : (
        <div className="max-w-md text-center">
          <h1 data-testid="payment-result-title" className="font-serif font-light text-4xl md:text-5xl tracking-tight">
            {title}
          </h1>
          <p className="mt-5 text-foreground/70 leading-relaxed">{body}</p>
          <Link
            to="/schulungen"
            data-testid="payment-back"
            className="group mt-8 inline-flex items-center gap-3 bg-primary text-primary-foreground px-7 py-4"
          >
            <span className="text-sm tracking-wide">{t("academy.back")}</span>
            <ArrowRight strokeWidth={1.5} size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      )}
    </div>
  );
}
